import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { coachUserRoleArray } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';

@Component({
  selector: 'bxl-runner-view',
  templateUrl: 'runner-view.component.html',
  styleUrls: ['runner-view.component.scss']
})
export class RunnerViewComponent implements OnInit {
  initialized = false;
  clientUserId: number;
  hasCoachRole: boolean;


  constructor(private auth: AuthenticationService, private breadcrumbs: BreadcrumbsService, private router: Router) { }

  ngOnInit(): void {
    this.breadcrumbs.SetSecondaryBreadcrumb('Calendar', 'calendar', []);
    this.auth.fetchUserProfile().subscribe(user => {
      this.clientUserId = user.id;
      this.hasCoachRole = this.auth.hasClaimForRole(coachUserRoleArray);
      this.initialized = true;
    });
  }
}
